<template>
	<div id="becproperties-index"
		 class="app-home ui-styles"
		 :class="theme">
		<spinner v-if="loading">
		</spinner>

		<template v-else>

			<side-nav-bar :fileOpen="fileOpen"></side-nav-bar>
			<div class="app-container">
				<bar>
				</bar>
				<h1><span>{{ $t('Construction_prices') }}</span> </h1>
				<div>
					<div @click.prevent="onCreateNewBecProperty" style="width: fit-content; margin-left: auto">
						<icon-button icon="plus-circle" :text="new_becproperty_button_text"
									 icon_color="black"
									 text_color="black" border_color="lightgray"></icon-button>
					</div>
				</div>
				<div>
					<form class="bt-form">
						<div class="form-section">
							<h3>{{ $t('Property_types') }}</h3>
							<div v-if="_.size(becproperties) > 0">
								<div class="grid-row" layout="row top-stretch">
									<div class="grid-cell" layout="row">
										<input type="text" :placeholder="filter_placeholder" self="size-x1"
											   v-model="becproperties_table.filter"
											   data-intro="You can filter the data in a datatable by typing in any of the filter fields"
											   data-step="9" data-position="top">
									</div>
								</div>
								<div class="grid-row" layout="row top-stretch">
									<div class="grid-cell">
										<paginator :source="this.object_to_array(becproperties)"
												   :page-size="20"
												   :filter="becproperties_table.filter"
												   data-intro="Use the paginator to page data for easier viewing"
												   data-step="10"
												   data-position="top">
											<template scope="page">
												<datatable id="data-table-becproperties"
														   :source="page.data"
														   :filterable="false"
														   :striped="becproperties_table.striped"
														   :editable="becproperties_table.editable"
														   :line-numbers="becproperties_table.lineNumbers">
													<datatable-column
															v-for="column in becproperties_table.columns"
															:id="column.id"
															:label="column.label"
															:width="column.width"
															:sortable="column.sortable"
															:groupable="column.groupable"
															:formatter="column.formatter">
													</datatable-column>
													<datatable-column id="actions-becproperties" :label="actions_text"
																	  :sortable="false"
																	  :groupable="false"></datatable-column>
													<template slot="actions-becproperties" scope="cell">
														<table class="actions-table">
															<tr>
																<td><a @click="editBecProperty(cell.row)"
																	   style="cursor: pointer;" :title="edit_text">
																	<icon name="pencil" scale="1" color="gray"></icon>
																</a></td>
																<td><a @click="duplicateBecProperty(cell.row)"
																	   style="cursor: pointer;" :title="duplicate_text">
																	<icon name="files-o" scale="1" color="gray"></icon>
																</a></td>
																<td><a @click="deleteBecProperty(cell.row)"
																	   style="cursor: pointer;" :title="delete_text">
																	<icon name="trash-o" scale="1" color="gray"></icon>
																</a></td>
															</tr>
														</table>


													</template>
												</datatable>
											</template>
										</paginator>
									</div>
								</div>
							</div>

						</div>

					</form>
				</div>

<!--
				<bar>
				</bar>
-->
			</div>

		</template>
	</div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex'
    import Vue from 'vue'
    import _ from 'lodash'
    import moment from 'moment'
    import router from '../../../router'
    import { dateMixin, localStorageMixin, objectsMixin } from '../../../mixins'
    import Spinner from '../../../components/Spinner.vue'
    import Search from '../../../components/ContactsSearch/Index.vue'
    import Editor from '../../../components/Editor/Index.vue'
    import Bar from '../../../components/Bar/Index.vue'
    import IconButton from '../../../components/IconButton/Index.vue'
    import SideNavBar from '../../../components/SideNavBar/Index.vue'

    import Message from '../../../components/Message.vue'
    import SuccessMessage from '../../../components/SuccessMessage.vue'

    import honorificTitleOptions from '../../../options/honorific_titles'
    import personTypeOptions from '../../../options/person_types'

    import Datatable from '../../../components/Datatable/datatable.vue'
    import DatatableColumn from '../../../components/Datatable/datatable-column.vue'
    import aggregators from '../../../aggregators/aggregators.js'
    import formatters from '../../../formatters/formatters.js'
    import Checkbox from '../../../components/Toggles/checkbox.vue'
    import Paginator from '../../../components/Paginator/paginator.vue'

    export default {
        name: 'becproperties-index',

        mixins: [
            dateMixin,
            localStorageMixin,
            objectsMixin
        ],

        data: () => ({
            loading: false,
            fileOpen: false,
            filter_placeholder: Vue.i18n.translate('Type_here_to_filter_paginated_data'),
            new_appraisalreport_button_text: Vue.i18n.translate('Add_appraisal_report'),
            new_becproperty_button_text: Vue.i18n.translate('Add_bec_property'),
            cancel_button_text: Vue.i18n.translate('Cancel'),
            goback_button_text: Vue.i18n.translate('Go_back') + ' ' + Vue.i18n.translate('without_saving'),
            goup_button_text: Vue.i18n.translate('Go_up') + ' ' + Vue.i18n.translate('without_saving'),
            save_button_text: Vue.i18n.translate('Save') + ' ' + Vue.i18n.translate('and') + ' ' + Vue.i18n.translate('go_up'),
            cad_ref_error_text_01: Vue.i18n.translate('Cadastral_Reference_less_20_positions_error_text'),
            page_dirty_text: Vue.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: Vue.i18n.translate('Actions'),
            duplicate_text: Vue.i18n.translate('Duplicate'),
            edit_text: Vue.i18n.translate('Edit'),
            delete_text: Vue.i18n.translate('Delete'),
            value: null,
            ms_placeholder: Vue.i18n.translate('Pick_an_option'),
            error: null,
            success_message: null,
            honorificTitleOptions,
            personTypeOptions,
            becproperties_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: "EUR",
                dateFormat: "DD/MM/YYYY",
                columns: [
                    {
                        id: "name_es",
                        label: Vue.i18n.translate('Name'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: "date_modified",
                        label: Vue.i18n.translate('Last_modified'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return moment(value).format('DD/MM/YYYY HH:mm:ss')
                        }
                    }
                ],
                selected: []
            }
        }),

        components: {
            Bar,
            Message,
            SuccessMessage,
            IconButton,
            Spinner,
            Checkbox,
            Datatable,
            DatatableColumn,
            Paginator,
            SideNavBar
        },

        computed: {
            ...mapGetters([
                'theme',
                'currentLocale',
                'becproperties',
            ])
        },

        created () {
            this.FETCH_BECPROPERTIES()
                .then(() => {
                    this.loading = false

                })
        },

        methods: {
            ...mapActions(
                [
                    'FETCH_BECPROPERTIES',
                    'CREATE_NEW_BECPROPERTY',
                    'SET_BECPROPERTY',
                    'RESET_BECPROPERTY',
                    /*
                    'DELETE_BECPROPERTYREPORT',
                    'FETCH_ALL_REALESTATE_BECPROPERTIES',
                    'FETCH_BECPROPERTYFILE_BECPROPERTYREPORTS',

                    'GET_BECPROPERTYREPORT',

                    'SET_BECPROPERTYFILE_DESCRIPTION',
                    'SET_BECPROPERTYFILE_NUMBER',
                    'UPDATE_BECPROPERTYFILE',
                    'UPDATE_BECPROPERTYREPORT'
                    */
                ]),
            onCreateNewBecProperty: function () {
                this.master_loading = true
				this.RESET_BECPROPERTY().then(() =>{
                    this.CREATE_NEW_BECPROPERTY({
                        path: 'becproperties' + '/'
                    }).then((res) => {
                        this.master_loading = false
                        this.$router.push({name: 'becproperty-editor', query: {id: res.key}})
                    })
				})

            },

            duplicateBecProperty: function (entity) {

                /*

                this.loading = true

                const new_versionnumber = entity.version + 1

                this.RESET_BECPROPERTYREPORT().then((res) => {
                    this.CREATE_NEW_BECPROPERTYREPORT({
                        path: 'appraisalreports' + '/',
                        parent_path: 'appraisalfiles' + '/' + this.appraisalfile.id + '/' + 'appraisalreports' + '/',
                        file_id: this.appraisalfile.id,
                        number: entity.number,
                        version: new_versionnumber
                    }).then((res) => {

                        console.log('duplicateBecProperty then res:')
						console.log(res)

                        const new_object_id = res.key
                        const new_object_version = new_versionnumber

                        this.GET_BECPROPERTYREPORT({ path: 'appraisalreports' + '/' + entity.id }).then((res) => {

                            console.log(' *^*^*^*^*^*^*^*^*^*^get appraisal report res: ')
							console.log(res)

                            let new_object = res
							new_object.id = new_object_id
							new_object.version = new_object_version


                            this.UPDATE_BECPROPERTYREPORT({
                                object: new_object,
                                path: 'appraisalreports/',
                                parent_path: 'appraisalfiles' + '/' + this.appraisalfile.id + '/' + 'appraisalreports' + '/',
                                key: new_object_id
                            }).then((res) => {

                                this.loading = true
                                this.FETCH_BECPROPERTYFILE_BECPROPERTYREPORTS({path: 'appraisalfiles' + '/' + this.$route.query.id + '/' + 'appraisalreports'})
                                    .then(() => {
                                        this.loading = false
                                    })

                            })

						})


                    })
                })
                */

            },
            onGoBack: function () {
                // console.log('yeah back')
                router.go(-1)
            },
            onGoUp: function () {
                // console.log('yeah back')
                this.$router.push({name: 'appraisalfiles-index'})
            },
            onSaveCurrentAppraisalFile: function (data) {

                /*
                console.log('appraisalfile.id: ')
                console.log(this.appraisalfile.id)
                this.UPDATE_BECPROPERTYFILE({
                    object: this.appraisalfile,
                    path: 'appraisalfiles' + '/' + this.appraisalfile.id
                }).then((res) => {
                    if (data.goback) {
                        this.$router.push({name: 'appraisalfiles-index'})
                    }
                })
                */
            },
            editBecProperty: function (entity) {
                this.SET_BECPROPERTY({path: 'becproperties' + '/' + entity.id + '/'}).then((res) => {
                    this.$router.push({name: 'becproperty-editor', query: {id: entity.id}})

                })
            },
            deleteBecProperty: function (entity) {

                /*

                const result = window.confirm(Vue.i18n.translate("You_are_about_to_delete ") + entity.filenumber + ', ' + entity.filedescription + ". " + Vue.i18n.translate("Continue_q"))

                if (result) {

                    this.DELETE_BECPROPERTYREPORT({
                        file_id: this.appraisalfile.id,
                        path: 'appraisalreports' + '/' + entity.id,
                        key: entity.id,
                        parent_path: 'appraisalfiles' + '/' + this.appraisalfile.id + '/' + 'appraisalreports' + '/' + entity.id
                    }).then((res) => {
                        //
                        this.loading = true
                        this.FETCH_BECPROPERTYFILE_BECPROPERTYREPORTS({path: 'appraisalfiles' + '/' + this.$route.query.id + '/' + 'appraisalreports'})
                            .then(() => {
                                this.loading = false
                            })
                    })

                }
                */

            }
        },
        head: {
            title: {
                //inner: Vue.i18n.translate('New_appraisalfile')
                inner: 'Bec Properties'
            }
        }

    }
</script>


// WEBPACK FOOTER //
// BecPropertiesIndex.vue?33c0fc82